import React from 'react';
import { ChangePassword } from '@silverrailtech/srtlibrary';

import { postCustomerAccountAction } from '../../../../api';
import useAuth from '../../../../hooks/useAuth';
import useRequestor from '../../../../hooks/useRequestor';

const ResendEmail = () => {
	const { getAuthHeaders, accountId } = useAuth();
	const { apiCallWithAuthRetry } = useRequestor();

	const sendResetEmail = () =>
		new Promise((resolve, reject) => {
			apiCallWithAuthRetry({
				apiCall: (onError, onSuccess, refreshedHeaders) => {
					postCustomerAccountAction(
						{},
						refreshedHeaders || getAuthHeaders(),
						`/${accountId}/reset-password`,
						onError,
						onSuccess,
					);
				},
				onError: (err) => {
					reject(err);
				},
				onSuccess: () => {
					resolve();
				},
			});
		});

	const props = {
		isAgent: true,
		sendResetEmail,
	};

	return <ChangePassword {...props} />;
};

export default ResendEmail;
